
import { ajaxGet } from '@framework/Services';

export function start(options: { routes: JSX.Element[] }) {

}

export type LicensableModule =
  "AgileBPMS" |
  "Collaboration" |
  "ActiveDirectoryAuthorizer" |
  "TrustedApi" |
  "CRM" |
  "IMMS" |
  "Training" |
  "HRM" |
  "Inventory" |
  "Payment" |
  "Behin" |
  "SMS" |
  "Mailing" |
  "DynamicClient" | 
  "Zarazma" |
  "SGAmin" | 
  "SignUp" | 
  "Isolation";

  //"Accounting" |
  //"Asset" |
  //"Health" |
  //"Afagh" |
  //"Order" |
  //"Reward" |
  //"PM" |
  //"Forwarder" |
  //"MeetingReport" |
  //"Canteen" |
  //"Welfare" |
  //"RollCall" |
  //"ElecSales" |
  //"Kooloon" |
  //"HelpDesk";

export var licensedModules: LicensableModule[] = [];
export var licenseInfo: LicenseInfo;

export function getLicensedModules(): Promise<void> {
  return ajaxGet<string[]>({ url: `~/api/license/licensedModules` })
    .then(res => { licensedModules = (res as LicensableModule[]); return undefined; });
}

export function getLicenseInfo(): Promise<void> {
  return ajaxGet<LicenseInfo>({ url: `~/api/license/licenseInfo` })
    .then(res => { licenseInfo = res; return undefined; });
}

export function isLicensed(moudleName: LicensableModule): boolean {
  return licensedModules.contains(moudleName);
}

export interface LicenseInfo {
  now: string;
  customerName: string;
  companyName: string;
  companyURL: string;
  productName: string;
  expired: boolean;
}
